import toast from "react-hot-toast";
import {
    getToken,
    getToken2,
    getUser,
    refreshPage,
    toastStyle,
} from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2 } from "./axiosMethodCalls";

/***************************
 * FILTER
 ***************************/

const user = getUser();
const token = getToken();

//POST
// Save user to both db
export const createUser = async (data) => {

    try {
        const formData = new FormData();
        data.attachments.map((file) => {
            formData.append(`attachments[]`, file, file.name);
        })
        formData.append('requester', getUser());
        formData.append('token', getToken());
        formData.append('username', data.username ? data.username : "");
        formData.append('password', data.password ? data.password : "");
        formData.append('last_name', data.last_name ? data.last_name : "");
        formData.append('first_name', data.first_name ? data.first_name : "");
        formData.append('middle_name', data.middle_name ? data.middle_name : "");
        formData.append('employee_id', data.employee_id ? data.employee_id : "");
        formData.append('email', data.email ? data.email : "");
        formData.append('type', data.type ? data.type : "");
        // formData.append('branch_id', data.branch_id ? data.branch_id : "");
        data.branch_id && formData.append(`branch_id`,data.branch_id);
        formData.append('terminal_id', data.terminal_id ? data.terminal_id : "");

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "users/create",
            formData,
            true
        );

        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const editUser = async (data) => {
    try {
        const formData = new FormData();
        data.attachments.map((file) => {
            formData.append('attachments[]', file, file.name);
            formData.append('attachment_ids[]', null);
        });
        data.prev_files.map((file) => {
            formData.append('attachment_ids[]', file.id);
        });
        formData.append('requester', getUser());
        formData.append('token', getToken());
        formData.append('user_id', data.id ? data.id : "");
        formData.append('username', data.username ? data.username : "");
        formData.append('password', data.password ? data.password : "");
        formData.append('last_name', data.last_name ? data.last_name : "");
        formData.append('first_name', data.first_name ? data.first_name : "");
        formData.append('middle_name', data.middle_name ? data.middle_name : "");
        formData.append('employee_id', data.employee_id ? data.employee_id : "");
        formData.append('email', data.email ? data.email : "");
        formData.append('type', data.type ? data.type : "");
        // formData.append('branch_id', data.branch_id ? data.branch_id : "");
        data.branch_id && formData.append(`branch_id`,data.branch_id);
        formData.append('terminal_id', data.terminal_id ? data.terminal_id : "");

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "users/update",
            formData,
            true
        );

        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const editPassword = async (id, password, token, userKey, userId) => {
    let config = {
        headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            "user-key": userKey,
            "Content-Type": "application/json",
        },
    };
    try {
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "users/change_password",
            {
                requester: id,
                user_id: userId,
                token: token,
                password: password,
            },
            config
        );
        return { data: response.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account",
                { style: toastStyle() }
            );
            //   removeSession();
        }
        return { error: error.response };
    }
};

export const getSingleUser = async (user_id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "users/get_user",
            {
                requester: user,
                token: token,
                user_id: user_id
            }
        );
        return { data: response.data.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account",
                { style: toastStyle() }
            );
            //   removeSession();
        }
        return { error: error.response };
    }
};

export const getAllUsers = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "users/get_all_user",
            {
                requester: user,
                token: token,
            }
        );
        return { data: response.data.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account",
                { style: toastStyle() }
            );
        }
        return { error: error.response };
    }
};

export const searchUser = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "users/search",
            {
                requester: user,
                token: token,
                name: data.name,
                type: data.type,
                branch_id: data.branch_id,
                page: data.page
            }
        );
        return { data: response.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account",
                { style: toastStyle() }
            );
            //   removeSession();
        }
        return { error: error.response };
    }
};

// export const searchUser = async (data) => {
//     try {
//         const response = await postAPICall(process.env.REACT_APP_LINK + 'users/search', {
//             requester: user,
//             token: token,
//             name: data,
//         });
//         return ({ data: response });
//     } catch (error) {
//         if (error.response.status === 401) {
//           toast.error(
//             "Unauthorized access: another device is using this account", {style: toastStyle(),}
//           );
//         //   removeSession();

//         }
//         return ({ error: error.response });
//     }
// }

export const deleteUser = async (user_id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "users/delete",
            {
                requester: user,
                token: token,
                user_id: user_id
            }
        );
        return { data: response.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account",
                { style: toastStyle() }
            );
            //   removeSession();
        }
        return { error: error };
    }
};

export const getAllRoles = async () => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "roles/filtered_get",
            {
                requester: user,
                token: token,
            }
        );
        return { data: response.data.data };
    } catch (error) {
        if (error.response.status === 401) {
            toast.error(
                "Unauthorized access: another device is using this account"
            );
            //   removeSession();
        }
        return { error: error.response };
    }
};
